module.exports = __webpack_public_path__ + "img/accepted-interest-free-cards.1f7213d7.png";